// extracted by mini-css-extract-plugin
export var colorSquare = "_r8-0";
export var danger = "_r8-5";
export var lightPink = "_r8-8";
export var neutralBlue = "_r8-7";
export var neutralYellow = "_r8-6";
export var normal = "_r8-1";
export var primary = "_r8-2";
export var primaryLight = "_r8-3";
export var solidBlack = "_r8-g";
export var solidGreen = "_r8-b";
export var solidLightBlue = "_r8-d";
export var solidNavy = "_r8-c";
export var solidOrange = "_r8-f";
export var solidPink = "_r8-e";
export var solidRed = "_r8-9";
export var solidYellow = "_r8-a";
export var success = "_r8-4";